import React from 'react'

import { MapMarkerIcon } from '@application/Interfaces/Icons'

import { IconWrapper, MapMarkerWrapper, Title } from './MapMarker.styled'

export type Props = {
    className?: string
    highlight?: boolean
    title: string
    lat?: number
    lng?: number
    onClick?: () => void
}

export const MapMarker = ({ className, title, highlight = false, onClick }: Props): JSX.Element => {
    return (
        <MapMarkerWrapper className={className} onClick={onClick} data-testid="MapMarker">
            <IconWrapper>
                <MapMarkerIcon colorCode={highlight ? 'a500' : 'black'} />
            </IconWrapper>
            <Title $highlight={highlight}>{title}</Title>
        </MapMarkerWrapper>
    )
}
